import './ListItem.css.proxy.js';
/* src/components/ListItem.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	destroy_each,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	space,
	text as text_1
} from "../web_modules/svelte/internal.js";

import { timeFormat } from "../web_modules/d3.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (28:4) {#each splitLinks as link}
function create_each_block(ctx) {
	let a;
	let span0;
	let t0_value = /*removeChrome*/ ctx[4](/*link*/ ctx[9]).split("/")[0] + "";
	let t0;
	let t1;
	let span1;
	let t2_value = /*removeChrome*/ ctx[4](/*link*/ ctx[9]) + "";
	let t2;
	let t3;
	let a_href_value;
	let a_title_value;

	return {
		c() {
			a = element("a");
			span0 = element("span");
			t0 = text_1(t0_value);
			t1 = space();
			span1 = element("span");
			t2 = text_1(t2_value);
			t3 = space();
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", { href: true, class: true, title: true });
			var a_nodes = children(a);
			span0 = claim_element(a_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, t0_value);
			span0_nodes.forEach(detach);
			t1 = claim_space(a_nodes);
			span1 = claim_element(a_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t2 = claim_text(span1_nodes, t2_value);
			span1_nodes.forEach(detach);
			t3 = claim_space(a_nodes);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span0, "class", "base svelte-fu7zh6");
			attr(span1, "class", "full svelte-fu7zh6");
			attr(a, "href", a_href_value = /*link*/ ctx[9]);
			attr(a, "class", "link svelte-fu7zh6");
			attr(a, "title", a_title_value = /*link*/ ctx[9]);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, span0);
			append(span0, t0);
			append(a, t1);
			append(a, span1);
			append(span1, t2);
			append(a, t3);
		},
		p(ctx, dirty) {
			if (dirty & /*splitLinks*/ 4 && t0_value !== (t0_value = /*removeChrome*/ ctx[4](/*link*/ ctx[9]).split("/")[0] + "")) set_data(t0, t0_value);
			if (dirty & /*splitLinks*/ 4 && t2_value !== (t2_value = /*removeChrome*/ ctx[4](/*link*/ ctx[9]) + "")) set_data(t2, t2_value);

			if (dirty & /*splitLinks*/ 4 && a_href_value !== (a_href_value = /*link*/ ctx[9])) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*splitLinks*/ 4 && a_title_value !== (a_title_value = /*link*/ ctx[9])) {
				attr(a, "title", a_title_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

function create_fragment(ctx) {
	let div2;
	let div0;
	let t0;
	let t1;
	let h3;
	let t2;
	let t3;
	let p;
	let t4;
	let t5;
	let div1;
	let each_value = /*splitLinks*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			t0 = text_1(/*editionString*/ ctx[3]);
			t1 = space();
			h3 = element("h3");
			t2 = text_1(/*headline*/ ctx[0]);
			t3 = space();
			p = element("p");
			t4 = text_1(/*text*/ ctx[1]);
			t5 = space();
			div1 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			div2 = claim_element(nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div0 = claim_element(div2_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			t0 = claim_text(div0_nodes, /*editionString*/ ctx[3]);
			div0_nodes.forEach(detach);
			t1 = claim_space(div2_nodes);
			h3 = claim_element(div2_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t2 = claim_text(h3_nodes, /*headline*/ ctx[0]);
			h3_nodes.forEach(detach);
			t3 = claim_space(div2_nodes);
			p = claim_element(div2_nodes, "P", { class: true });
			var p_nodes = children(p);
			t4 = claim_text(p_nodes, /*text*/ ctx[1]);
			p_nodes.forEach(detach);
			t5 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div1_nodes);
			}

			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "edition");
			attr(h3, "class", "headline svelte-fu7zh6");
			attr(p, "class", "text svelte-fu7zh6");
			attr(div1, "class", "links");
			attr(div2, "class", "c svelte-fu7zh6");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			append(div0, t0);
			append(div2, t1);
			append(div2, h3);
			append(h3, t2);
			append(div2, t3);
			append(div2, p);
			append(p, t4);
			append(div2, t5);
			append(div2, div1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div1, null);
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*editionString*/ 8) set_data(t0, /*editionString*/ ctx[3]);
			if (dirty & /*headline*/ 1) set_data(t2, /*headline*/ ctx[0]);
			if (dirty & /*text*/ 2) set_data(t4, /*text*/ ctx[1]);

			if (dirty & /*splitLinks, removeChrome*/ 20) {
				each_value = /*splitLinks*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div1, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);
			destroy_each(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { headline = "" } = $$props;
	let { text = "" } = $$props;
	let { links = "" } = $$props;
	let { edition = "" } = $$props;
	let { date = "" } = $$props;
	let { hattips = "" } = $$props;
	const removeChrome = str => str.replace(/^(http:\/\/www\.)/, "").replace(/^(https:\/\/www\.)/, "").replace(/^(www\.)/, "").replace(/^(http:\/\/)/, "").replace(/^(https:\/\/)/, "");

	$$self.$$set = $$props => {
		if ("headline" in $$props) $$invalidate(0, headline = $$props.headline);
		if ("text" in $$props) $$invalidate(1, text = $$props.text);
		if ("links" in $$props) $$invalidate(5, links = $$props.links);
		if ("edition" in $$props) $$invalidate(6, edition = $$props.edition);
		if ("date" in $$props) $$invalidate(7, date = $$props.date);
		if ("hattips" in $$props) $$invalidate(8, hattips = $$props.hattips);
	};

	let splitLinks;
	let editionString;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*links*/ 32) {
			$: $$invalidate(2, splitLinks = links.split("\n"));
		}

		if ($$self.$$.dirty & /*date*/ 128) {
			$: $$invalidate(3, editionString = timeFormat("%b %Y")(date));
		}
	};

	return [
		headline,
		text,
		splitLinks,
		editionString,
		removeChrome,
		links,
		edition,
		date,
		hattips
	];
}

class ListItem extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			headline: 0,
			text: 1,
			links: 5,
			edition: 6,
			date: 7,
			hattips: 8
		});
	}
}

export default ListItem;
//# sourceMappingURL=ListItem.js.map
